import React from "react";
import { Container } from "@insightfulscience/atomic-react/Grid";
import Testimonial from "@insightfulscience/atomic-react/Testimonial/Testimonial";
import {
	TestimonialColInfo,
	TestimonialColLogo,
} from "@insightfulscience/atomic-react/Testimonial/Grid";
import Image from "@insightfulscience/atomic-react/Image";
import TestimonialBlockQuote from "@insightfulscience/atomic-react/Testimonial/BlockQuote";
import TestimonialTabs from "@insightfulscience/atomic-react/Testimonial/Tabs";
import TestimonialTabsItem from "@insightfulscience/atomic-react/Testimonial/Tab";
import useTestimonial from "@insightfulscience/atomic-react/Testimonial/hooks/useTestimonial";
import { useLocale } from "@insightfulscience/smart-react/i18";
import { arrayOf, shape, string } from "prop-types";

const Testimonials = ({ testimonials }) => {
	const [t] = useLocale("customers-page");
	const [active, activeIndex, setActiveIndex] = useTestimonial(testimonials);

	return (
		<>
			<Container spacing={{ sm: { px: 0 } }}>
				<Testimonial mx spacing={{ mb: 8, sm: { px: 2 } }}>
					<TestimonialColLogo md={4} lg={2} spacing={{ sm: { mb: 8 } }}>
						<Image src={t(active.colorLogo)} />
					</TestimonialColLogo>
					<TestimonialColInfo md={8} lg={10} spacing={{}}>
						<TestimonialBlockQuote author={t(active.author)} company={t(active.company)}>
							{t(active.text)}
						</TestimonialBlockQuote>
					</TestimonialColInfo>
				</Testimonial>
			</Container>
			<Container>
				<TestimonialTabs>
					{testimonials.map(({ monochrome }, index) => (
						<TestimonialTabsItem
							key={t(monochrome)}
							logoImg={t(monochrome)}
							invert="white"
							active={activeIndex === index}
							onClick={() => setActiveIndex(index)}
						/>
					))}
				</TestimonialTabs>
			</Container>
		</>
	);
};

Testimonials.propTypes = {
	testimonials: arrayOf(
		shape({
			colorLogo: string,
			monochrome: string,
			author: string,
			company: string,
			text: string,
		}),
	).isRequired,
};

export default Testimonials;
